import { Module } from 'vuex';
import { InfodaycoUploadActions } from '@/modules/infodayco/upload/store/infodayco-upload.actions';
import tutorialsRepository from '@/modules/infodayco/shared/repositories/tutorials.repository';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import { Exception } from '@/modules/shared/shared/domain/exceptions/exception';
import { VideoTutorial } from '@/modules/infodayco/shared/domain/video-tutorial';
import { FileCreationRequest } from '@/modules/infodayco/shared/domain/file-creation.request';
import serviceModelRepository from '@/modules/infodayco/shared/repositories/service-model.repository';

const infodaycoUpload: Module<any, any> = {
    namespaced: true,
    actions: {
        async [InfodaycoUploadActions.UPLOAD_TUTORIAL](
            {},
            tutorial: FileCreationRequest,
        ): Promise<RequestResponse> {
            try {
                const upload = await tutorialsRepository.uploadTutorial(tutorial);
                EventBus.$emit(
                    EventBusMessages.SHOW_SUCCESS,
                    `Se ha cargado el archivo exitosamente (Nombre del archivo: ${upload.name})`,
                );
                return false;
            } catch (e) {
                return new Exception(e.response);
            }
        },
        async [InfodaycoUploadActions.UPLOAD_VIDEO_TUTORIAL](
            {},
            tutorial: VideoTutorial,
        ): Promise<RequestResponse> {
            try {
                const upload = await tutorialsRepository.uploadVideoTutorial(tutorial);
                EventBus.$emit(
                    EventBusMessages.SHOW_SUCCESS,
                    `Se ha cargado el vídeo exitosamente (Nombre del vídeo: ${upload.name})`,
                );
                return false;
            } catch (e) {
                return new Exception(e.response);
            }
        },
        async [InfodaycoUploadActions.UPLOAD_GUIDE](
            {},
            guide: FileCreationRequest,
        ): Promise<RequestResponse> {
            try {
                const upload = await serviceModelRepository.uploadServiceModel(guide);
                EventBus.$emit(
                    EventBusMessages.SHOW_SUCCESS,
                    `Se ha cargado el arhivo exitosamente (Nombre del vídeo: ${upload.name})`,
                );
                return false;
            } catch (e) {
                return new Exception(e.response);
            }
        },
    },
};

export default infodaycoUpload;
